module.exports = __webpack_public_path__ + "static/media/fulltime_latam.bbaf9495.png";